export enum Flags {
    LEADS_WITHOUT_CONTACTED = 'LEADS_WITHOUT_CONTACTED',
}

export const FlagLabels = [
    { value: Flags.LEADS_WITHOUT_CONTACTED, label: 'EDM NOT Contacted' },
];
